import type { HotelSummary } from './api/types';

const AMENITY_PRIORITIES = ['pool', 'spa', 'breakfast', 'parking', 'garden', 'smoking', 'beach', 'fitness', 'family', 'wifi'];

export function shortRoomType(roomName?: string | null) {
  if (!roomName) return null;
  const concise = roomName.split('(')[0].split(',')[0].split(' - ')[0].trim();
  return concise || null;
}

export function decisionAmenities(amenities: string[] = [], limit = 3) {
  return [...amenities]
    .sort((a, b) => {
      const rank = (value: string) => {
        const normalized = value.toLowerCase();
        const index = AMENITY_PRIORITIES.findIndex((item) => normalized.includes(item));
        return index === -1 ? AMENITY_PRIORITIES.length : index;
      };
      return rank(a) - rank(b);
    })
    .filter((value, index, all) => all.findIndex((item) => item.toLowerCase() === value.toLowerCase()) === index)
    .slice(0, limit);
}

export function taxStatusLabel(hotel: HotelSummary) {
  if (hotel.searchOffer?.taxesIncluded === true) return 'Taxes included';
  if (hotel.searchOffer?.taxesIncluded === false) return 'Taxes excluded';
  if (hotel.searchOffer?.totalPrice) return 'With taxes & fees';
  return 'Tax status at checkout';
}
